import { LinkDetails } from '../../../../types/types';
import { getInternalLinkData, SPXAPI } from '../../../../api';

const fetchAuthenticatedLinkDetails = (
    API: SPXAPI,
    linkId: string,
    hasApiProxy = false,
): Promise<LinkDetails> => (
    getInternalLinkData(API, linkId, hasApiProxy)
);

export default fetchAuthenticatedLinkDetails;
